import { render, staticRenderFns } from "./WorkerButtonsWidget.vue?vue&type=template&id=4cdb78c9&scoped=true&"
import script from "./WorkerButtonsWidget.vue?vue&type=script&lang=ts&"
export * from "./WorkerButtonsWidget.vue?vue&type=script&lang=ts&"
import style0 from "./WorkerButtonsWidget.vue?vue&type=style&index=0&id=4cdb78c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdb78c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
